/**
 * C-02 고객 목록 화면의 정적 표시 데이터입니다.
 * 실 서버 고객정보와 연결하지 않고, 식별 불가능한 예시값만 제공합니다.
 */

export type LegacyCustomerSearchRow = {
  rowNumber: number
  registeredAt: string
  customerNo: string
  oldCustomerNo: string
  baby: string
  mother: string
  motherPhone: string
  father: string
  fatherPhone: string
  source: string
  hospital: string
  postnatalCare: string
  tmType: string
  tmManager: string
  tmStatus: string
  tmFeedback: string
  tmMemo: string
  dueDate: string
  birthDate: string
  contractCount: string
  shootCount: string
  smsCount: string
  totalAmount: string
  advanceAmount: string
  interimAmount: string
  balanceAmount: string
  deliveryAmount: string
  originOffice: string
  transferOffice: string
}

export const legacyCustomerSearchRows: LegacyCustomerSearchRow[] = Array.from({ length: 30 }, (_, index) => {
  const number = 30 - index
  const serial = String(number).padStart(3, '0')
  return {
    rowNumber: number,
    registeredAt: `2026-08-${String((number % 20) + 1).padStart(2, '0')}`,
    customerNo: `C-MOCK-${serial}`,
    oldCustomerNo: number % 3 === 0 ? `OLD-${serial}` : '-',
    baby: `아기 ${number}`,
    mother: `고객 ${number}`,
    motherPhone: `010-0000-${String(number).padStart(4, '0')}`,
    father: number % 2 === 0 ? `보호자 ${number}` : '-',
    fatherPhone: number % 2 === 0 ? `010-1000-${String(number).padStart(4, '0')}` : '-',
    source: number % 2 === 0 ? '온라인' : '소개',
    hospital: number % 3 === 0 ? '예시 산부인과' : '-',
    postnatalCare: number % 4 === 0 ? '예시 조리원' : '-',
    tmType: number % 2 === 0 ? '상담' : '-',
    tmManager: number % 2 === 0 ? '담당자 A' : '-',
    tmStatus: number % 2 === 0 ? '진행' : '-',
    tmFeedback: number % 5 === 0 ? '연락완료' : '-',
    tmMemo: number % 5 === 0 ? 'Mock 메모' : '-',
    dueDate: `2026-09-${String((number % 20) + 1).padStart(2, '0')}`,
    birthDate: number % 4 === 0 ? `2026-08-${String((number % 20) + 1).padStart(2, '0')}` : '-',
    contractCount: number % 3 === 0 ? '1' : '0',
    shootCount: number % 4 === 0 ? '1' : '0',
    smsCount: String(number % 6),
    totalAmount: number % 3 === 0 ? '350,000' : '0',
    advanceAmount: number % 3 === 0 ? '100,000' : '0',
    interimAmount: '0',
    balanceAmount: number % 3 === 0 ? '250,000' : '0',
    deliveryAmount: '0',
    originOffice: '데모지점',
    transferOffice: '-',
  }
})

const mockOptions = (prefix: string, count: number) => Array.from({ length: count }, (_, index) => `${prefix} ${String(index + 1).padStart(3, '0')}`)

export const legacyCustomerSearchOptions = {
  // 개발 원본 C-02의 숨김 선택 필드 옵션 수(26/198/89/80/29/29)를 유지한 비식별 Mock입니다.
  offices: mockOptions('데모지점', 26),
  visit: mockOptions('유입경로', 198),
  hospitals: mockOptions('산부인과', 89),
  postnatalCare: mockOptions('조리원', 80),
  additionalVisit1: mockOptions('추가경로1', 29),
  additionalVisit2: mockOptions('추가경로2', 29),
  tmTypes: ['전체', ...mockOptions('TM종류', 10)],
  tmManagers: ['전체', ...mockOptions('TM담당', 9)],
  tmStatuses: ['전체', ...mockOptions('TM상태', 7)],
  tmFeedbacks: ['-', '연락완료', '부재', '보류', '완료', '재연락'],
  pageLimits: ['30', '50', '100', '200', '500'],
}

export const legacyCustomerSearchColumns = [
  { key: 'source', label: '유입경로' },
  { key: 'hospital', label: '산부인과' },
  { key: 'postnatalCare', label: '조리원' },
  { key: 'tmType', label: 'TM종류' },
  { key: 'tmManager', label: 'TM담당' },
  { key: 'tmStatus', label: 'TM상태' },
  { key: 'tmFeedback', label: 'TM피드백' },
  { key: 'tmMemo', label: 'TM메모' },
] as const
